import { useCallback } from "react";

import { useRouter } from "next/navigation";

import { useEnvData } from "~/context/EnvDataContext";
import { useIsLoggedIn } from "~/queries/profile/useProfile";
import { signinUrlPath, signupUrlPath } from "~/utils/auth.utils";

const useRedirectToSigninSignup = () => {
  const router = useRouter();
  const env = useEnvData();
  const isLoggedIn = useIsLoggedIn();
  const urlPrefix = env.currentLocaleData?.data?.urlPrefix;

  const handleRedirectToSignupPage = useCallback(
    (source?: string, dest?: string) => {
      const url = signupUrlPath(source, dest, urlPrefix);
      router.push(url);
    },
    [urlPrefix, router],
  );

  const handleRedirectToSigninPage = useCallback(
    (source?: string, dest?: string) => {
      const url = signinUrlPath(source, dest, urlPrefix);
      router.push(url);
    },
    [urlPrefix, router],
  );

  return {
    isUserLoggedIn: isLoggedIn,
    handleRedirectToSignupPage,
    handleRedirectToSigninPage,
  };
};

export default useRedirectToSigninSignup;
